<template>
  <div class="user-info-bar">
    <md-field v-if="userInfo">
      <md-cell-item
        :title="userInfo.name"
        :brief="userInfo.userNo"
      >
        <div slot="left" class="holder">
          <svg-icon name="avatar" />
          <!-- <img :src="require('@/assets/user-icon.png')" alt="#"> -->
        </div>
      </md-cell-item>
    </md-field>
  </div>
</template>

<script>
import { Field, CellItem } from 'mand-mobile'

export default {
  name: 'WalletAccount',

  components: {
    [Field.name]: Field,
    [CellItem.name]: CellItem
  },

  props: {
    userInfo: {
      type: Object,
      default: null
    }
  }
}

</script>

<style lang="scss" scoped>

.user-info-bar {
  font-size: 16px;
  padding-top: 32px;
}

.holder { /* stylelint-disable declaration-block-no-duplicate-properties, selector-pseudo-element-no-unknown */
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #e6e6e6;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  .svg-icon {
    width: 80px;
    height: 80px;
  }
}

.md-field {
  padding: 0 24px;
  font-weight: 500;
  color: #333;
  height: 156px;
  border-radius: 32px;
  box-shadow: 0 4px 16px 0 rgba(138, 149, 158, 0.2);
}
// ::v-deep
::v-deep .md-cell-item-body {
  height: 156px;
}
// ::v-deep
::v-deep .md-cell-item-body::before {
  border-bottom: 0;
}

::v-deep .md-cell-item-brief {
  font-size: 32px;
  color: #333;
  font-weight: 400;
}
/* stylelint-enable */
</style>
